module.exports = __webpack_public_path__ + "static/media/shoe (16).c520633c.jpg";